// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import { Headline } from "#/components/headline/Headline";

@Component({
  name: "DownloadModule",
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class DownloadModule extends ModuleBase {
  public lang: string = "de";

  getBackgroundColorFromInstance(instance: object) {
    return instance["section_color"]["color"];
  }

  get downloads() {
    return this.instance["downloads"].slice();
  }

  downloadLink(download) {
    if (
      download.doc !== "" &&
      this.getTranslatedImage(download.doc, this.lang, "full")
    ) {
      return this.getTranslatedImage(download.doc, this.lang, "full");
    } else {
      return download.link;
    }
  }

  stats(download) {
    let stat = "";

    if (
      typeof download.doc === "object" &&
      download.doc[this.lang] !== null &&
      download.doc[this.lang] != [] &&
      download.doc[this.lang] !== 'DELETE_IMAGE'
    ) {
      if (download.doc[this.lang] && download.doc[this.lang].file_type !== "")
        stat +=
          download.doc[this.lang].file_type +
          (download.doc[this.lang].file_size !== "" ? ", " : "");

      if (download.doc[this.lang] && download.doc[this.lang].file_size !== "")
        stat += download.doc[this.lang].file_size;
    } else {
      if (download.doctype !== "") {
        stat += download.doctype + (download.docsize !== "" ? ", " : "");
      }

      if (download.docsize !== "") {
        stat += download.docsize;
      }
    }
    return stat;
  }
}
